export const COLORS = ["#ec2227", "#f15b29", "#f7ec13", "#079247", "#1f4497", "#643d97", "#000000", "#ffffff", "#e08827", "#3edd77", "#40b1dd", "#cc7add", "#6b615d", "#3db4d6"]
